import { useTranslation } from 'react-i18next';

export const useGetLabourEngagementStateLabel = (
  state: 'pending' | 'approved' | 'rejected' | 'terminated' | null | undefined
): string => {
  const { t } = useTranslation('ogp-screen-specific');

  switch (state) {
    case 'pending':
      return t('workforce.employee_detail_screen.labour_engagement_state.pending', {
        ns: 'ogp-screen-specific',
      });
    case 'approved':
      return t('workforce.employee_detail_screen.labour_engagement_state.approved', {
        ns: 'ogp-screen-specific',
      });
    case 'rejected':
      return t('workforce.employee_detail_screen.labour_engagement_state.rejected', {
        ns: 'ogp-screen-specific',
      });
    case 'terminated':
      return t('workforce.employee_detail_screen.labour_engagement_state.terminated', {
        ns: 'ogp-screen-specific',
      });
    default:
      return '';
  }
};

export const useGetEmployeeOnboardingStatusLabel = (isOnboarded: boolean): string => {
  const { t } = useTranslation('ogp-screen-specific');
  const isOnboardedLabel = t('workforce.employee_detail_screen.onboarding_status.is_onboarded', {
    ns: 'ogp-screen-specific',
  });
  const notOnboardedLabel = t('workforce.employee_detail_screen.onboarding_status.not_onboarded', {
    ns: 'ogp-screen-specific',
  });
  return isOnboarded ? isOnboardedLabel : notOnboardedLabel;
};
